/** android 传递的 country 值是大写, 需要进行小写转换 */
export type StoreArea = 'us' | 'uk' | 'de' | 'eu' | 'ca'

export type ILocal = 'en-US' | 'en-GB' | 'de' | 'ca' | 'de-EU'
export type ICurrency = 'USD' | 'GBP' | 'EUR' | 'CAD'
export const transCountryToStoreArea = (countryCode: string): StoreArea => {
  const storeArea = COUNTRY_CODE_STORE_MAP[countryCode.toUpperCase()]
  return (storeArea || 'us') as StoreArea
}

export const localBizMap: Record<ILocal, StoreArea> = {
  'en-US': 'us',
  'en-GB': 'uk',
  de: 'de',
  ca: 'ca',
  'de-EU': 'eu',
}

export const localCurrencyMap: Record<ILocal, ICurrency> = {
  'en-US': 'USD',
  'en-GB': 'GBP',
  de: 'EUR',
  ca: 'CAD',
  'de-EU': 'EUR',
}
// EU店铺对应的国家码
export const EU_STORE_COUNTRY_CODES = [
  'AT', // 奥地利
  'BE', // 比利时
  'BG', // 保加利亚
  'HR', // 克罗地亚
  'CZ', // 捷克
  'DK', // 丹麦
  'EE', // 爱沙尼亚
  'FI', // 芬兰
  'FR', // 法国
  'GR', // 希腊
  'HU', // 匈牙利
  'IT', // "意大利109/110 个省）"
  'LV', // 拉脱维亚
  'LT', // 立陶宛
  'LU', // 卢森堡
  'MT', // 马耳他
  'NL', // 荷兰
  'PL', // 波兰
  'PT', // 葡萄牙
  'RO', // 罗马尼亚
  'SK', // 斯洛伐克
  'SI', // 斯洛文尼亚
  'ES', // 西班牙（49/52 个省）
  'SE', // 瑞典
]
export const UK_STORE_COUNTRY_CODES = ['UK', 'GB']
export const DE_STORE_COUNTRY_CODES = ['DE']
export const US_STORE_COUNTRY_CODES = ['US']
export const CA_STORE_COUNTRY_CODES = ['CA']

export const STORE_COUNTRY_CODES_MAP: Record<StoreArea, string[]> = {
  us: US_STORE_COUNTRY_CODES,
  uk: UK_STORE_COUNTRY_CODES,
  de: DE_STORE_COUNTRY_CODES,
  ca: CA_STORE_COUNTRY_CODES,
  eu: EU_STORE_COUNTRY_CODES,
}

export const COUNTRY_CODE_STORE_MAP: Record<string, StoreArea> = {
  ...EU_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'eu'
    return o
  }, {} as Record<string, StoreArea>),
  ...UK_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'uk'
    return o
  }, {} as Record<string, StoreArea>),
  ...DE_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'de'
    return o
  }, {} as Record<string, StoreArea>),
  ...US_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'us'
    return o
  }, {} as Record<string, StoreArea>),
  ...CA_STORE_COUNTRY_CODES.reduce((o, code) => {
    o[code] = 'ca'
    return o
  }, {} as Record<string, StoreArea>),
}

export const SYS_ENV_STORE_MAP: Record<StoreArea, 'us' | 'eu'> = {
  us: 'us',
  uk: 'eu',
  de: 'eu',
  ca: 'us',
  eu: 'eu',
}
